import * as moment from "moment";

export enum Tag {
    Tmp,
    AppMain,
    CustomRouteReuseStrategy,

    OfferCoupon,
    OfferCouponOpen,
    OfferItem,
    OfferRedeemComponent,
    OffersList,
    BottomNavigationComponent,
    SlideComponent,
    PagerV1,
    PagerV2,
    PagerV3,
    SponsorHeader,

    ImageCache,
    ShareUtil,

    FilesService,
    StorageService,
    NavigationService,
    NetworkService,
    RPCService,
    NotificationService,
    HttpOfferService,
    SampleOfferService,
    OfferService,
    HttpUserProfileService,
    SampleUserProfileService,
    UserProfileService,
    TicketService,
    InteractionService,
    LocationService,
    SuspendService,
    SettingsService,

    LoginPage,
    AboutPage,
    SponsorPage,
    LocationPage,
    WelcomePage,
    PrivacyPolicyPage,
    NotificationsStatusPage,
    OffersPage,
    SearchingPage,
    SettingsPage,
    SharePage,
    ShowCashierPage,
    ThanksPage,
    SponsorVideoPage
    // HomePage
}

export enum Level {
    out = 0,
    fatal = 1,
    error = 2,
    warn = 3,
    info = 4,
    debug = 5,
    trace = 6
}

const logSettings = {
    defaultLevel: Level.info,
    levels: {
    }
};

let logBufferEndOffset: number = 0;
let logBufferStartOffset: number = 0;
let logBuffer: Array<string> = [];

function currentLogLevel(tag: Tag) {
    const level: Level = logSettings.levels[tag];
    return level ? level : logSettings.defaultLevel;
}

export function isLogging(tag: Tag, level: Level) {
    if (level === Level.out) {
        return true;
    }
    return currentLogLevel(tag) >= level;
}

function log(tag: Tag, level: Level, message: any) {
    if (isLogging(tag, level)) {
        if (typeof message === "object") {
            try {
                message = JSON.stringify(message, null, 2);
            } catch (error) {
                // just swallow error
            }
        }
        // [10/24 10:00:32.402 (2445)] http-apr-8443-exec-91 access:
        const levelStr = () => ("       " + "(" + String(Level[level]) + ")").slice(-7);
        const formattedDate = () => "[" + moment().format("MM/DD HH:mm:ss.SSS") + "]";
        console.log(formattedDate() + " " + levelStr() + " " + (tag ? Tag[tag] + ": " : "") + message);
        if (logBuffer.length > 0) {
            logBuffer[logBufferEndOffset] = formattedDate() + " " + levelStr() + " " + (tag ? Tag[tag] + ": " : "") + message;
            logBufferEndOffset++;
            logBufferEndOffset = logBufferEndOffset % logBuffer.length;
            if (logBufferEndOffset === logBufferStartOffset) {
                logBufferStartOffset++;
                logBufferStartOffset = logBufferStartOffset % logBuffer.length;
            }
        }
    }
}

export function setLogBufferSize(size: number) {
    logBufferStartOffset = 0;
    logBufferEndOffset = 0;
    logBuffer = new Array(size);
}

export function setDefaultLevel(level: Level|string) {
    if (typeof level === "string") {
        if (level === "error") {
            setDefaultLevel(Level.error);
        } else if (level === "warn") {
            setDefaultLevel(Level.warn);
        } else if (level === "info") {
            setDefaultLevel(Level.info);
        } else if (level === "debug") {
            setDefaultLevel(Level.debug);
        } else if (level === "trace") {
            setDefaultLevel(Level.trace);
        }
    } else {
        logSettings.defaultLevel = level;
    }
}

export function setTagLogLevel(tag: Tag, level: Level) {
    logSettings.levels[tag] = level;
}

export function getLogBufferText(): string {
    let logText = "";
    const length = logBuffer.length;
    let offset = logBufferStartOffset;
    if (logBufferEndOffset > 0 || logBufferStartOffset > 0) {
        while (true) {
            logText += (logBuffer[offset] + "\n");
            offset++;
            if (offset >= length) {
                offset = 0;
            }
            if (offset === logBufferEndOffset) {
                break;
            }
        }
    }
    return logText;
}

export function tmp(message: string) {
    log(Tag.Tmp, Level.out, message);
}

export function out(message: any) {
    log(null, Level.out, message);
}

export function fatal(tag: Tag, message: any) {
    log(tag, Level.fatal, message);
}

export function error(tag: Tag, message: any) {
    if (typeof message === "object" && message.stackTrace) {
        log(tag, Level.error, message.stackTrace);
    } else {
        log(tag, Level.error, message);
    }
}

export function warn(tag: Tag, message: any) {
    log(tag, Level.warn, message);
}

export function info(tag: Tag, message: any) {
    log(tag, Level.info, message);
}

export function debug(tag: Tag, message: any) {
    log(tag, Level.debug, message);
}

export function trace(tag: Tag, message: any) {
    log(tag, Level.trace, message);
}

export function isError(tag: Tag) {
    return isLogging(tag, Level.error);
}

export function isWarn(tag: Tag) {
    return isLogging(tag, Level.warn);
}

export function isInfo(tag: Tag) {
    return isLogging(tag, Level.info);
}

export function isDebug(tag: Tag) {
    return isLogging(tag, Level.debug);
}

export function isTrace(tag: Tag) {
    return isLogging(tag, Level.trace);
}
